// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3aXM0","subheader":"ReorderModal_subheader__2et3i","listWrap":"ReorderModal_listWrap__3Cy8Z"};